import * as React from 'react';
import {ContentBlock, Button, ContentBlockTitle} from 'framework7-react';
import {TourTimeline} from './TourTimeline';

export class Tour extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isListActive: true,
        }
    }

    getBuildingForSlug = (buildingSlug) =>
        this.props.buildings.find((b) => b.slug === buildingSlug);

    render() {
        let tourBuildings = [];

        this.props.tour.buildings.forEach((buildingSlug) =>
            tourBuildings.push(this.getBuildingForSlug(buildingSlug))
        );

        return (
            <div style={{paddingBottom: 60}}>
                <ContentBlockTitle>{this.props.tour.name}</ContentBlockTitle>

                <ContentBlock className="tour-map-button">
                        <Button className="active" onClick={() => this.props.openMap()} style={{margin: '0 auto', width: 115}}>View On Map</Button>
                </ContentBlock>

                <TourTimeline tour={this.props.tour} buildings={this.props.buildings}/>

                <i onClick={this.props.onClose} className="building-detail-upper-close f7-icons ">close_round</i>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Tour.jsx